/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Btn_ReloadInputs */

const en_ui_btn_reload = /** @type {(inputs: Ui_Btn_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload`)
};

const de_ui_btn_reload = /** @type {(inputs: Ui_Btn_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu laden`)
};

/**
* | output |
* | --- |
* | "Reload" |
*
* @param {Ui_Btn_ReloadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_btn_reload = /** @type {((inputs?: Ui_Btn_ReloadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Btn_ReloadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_btn_reload(inputs)
	return de_ui_btn_reload(inputs)
});